import { useEffect, useRef, useState } from 'react';

import { Link } from 'react-router-dom';

import {
    faFacebook,
    faInstagram,
    faLinkedinIn,
    faPinterestP,
    faTiktok,
    faWhatsapp,
    faXTwitter,
    faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useNotification } from '../Contexts/NotificationContext';

const icons = {
    facebook: faFacebook,
    instagram: faInstagram,
    x: faXTwitter,
    pinterest: faPinterestP,
    linkedin: faLinkedinIn,
    whatsapp: faWhatsapp,
    youtube: faYoutube,
    tiktok: faTiktok,
};

const HeaderAdditionalMenu = () => {
    const { setNotification } = useNotification();

    const navItems = [
        { name: 'Acessar Site', url: 'https://rometal.com.br/', isExternal: true },
        { name: 'Acessar Rometalks', url: 'https://rometal.com.br/rometalks', isExternal: true },
        { name: 'Contato', to: '/painel/contato', isExternal: false },
    ];

    const [links, setLinks] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchSocialLinks = async () => {
            try {
                const response = await fetch(`${baseUrl}/painel/redes-sociais`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setLinks(data.redes_sociais || []);
                } else {
                    throw new Error('Erro ao buscar as redes sociais');
                }
            } catch (error) {
                setNotification({
                    type: 'error',
                    message: error.message,
                    show: true,
                });
            }
        };

        fetchSocialLinks();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <ul className="flex items-center gap-2 2xsm:gap-4 mr-2 max-lg:hidden" ref={dropdownRef}>
            <li className="relative">
                <button
                    className="group relative flex h-8 w-8 items-center justify-center border-stroke"
                    onClick={(e) => {
                        e.preventDefault();
                        setDropdownOpen(!dropdownOpen);
                    }}
                >
                    <div className="absolute -inset-2 bg-white opacity-10 rounded-full transition-all group-hover:opacity-30" />
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 18 20"
                        width="18"
                        height="20"
                        className="fill-white opacity-50 transition-all group-hover:opacity-100"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M2 3h14a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z" />
                        <path d="M2 9h14a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z" />
                        <path d="M2 15h14a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z" />
                    </svg>
                </button>

                <div
                    className={`fixed right-0 top-0 min-h-[80vh] max-h-full bg-white z-10 transition-all ${dropdownOpen ? 'translate-x-0 shadow-lg' : 'translate-x-full'}`}
                >
                    <button
                        type="button"
                        className="absolute right-10 top-10"
                        onClick={(e) => {
                            setDropdownOpen(false);
                        }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 30 30"
                            width="30"
                            height="30"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M7 7L23 23" />
                            <path d="M23 7L7 23" />
                        </svg>
                    </button>

                    <div className="p-16 pt-24 overflow-y-auto">
                        <ul className="space-y-6 min-w-80">
                            {navItems.map((item, index) => (
                                <li key={index} className="flex items-center">
                                    {item.isExternal ? (
                                        <a
                                            href={item.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-primary text-xl font-semibold hover:text-secondary transition-colors"
                                        >
                                            {item.name}
                                        </a>
                                    ) : (
                                        <Link
                                            to={item.to}
                                            className="text-primary text-xl font-semibold hover:text-secondary transition-colors"
                                        >
                                            {item.name}
                                        </Link>
                                    )}
                                </li>
                            ))}
                        </ul>

                        <div className="flex gap-4 mt-20">
                            {links.map((rede) => (
                                <a
                                    key={rede.id}
                                    href={rede.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-tertiary hover:text-secondary transition-colors text-xl"
                                >
                                    {icons[rede.tipo] && <FontAwesomeIcon icon={icons[rede.tipo]} />}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    );
};

export default HeaderAdditionalMenu;
